import { ISmartReplyErrorTypes } from '@copilot/data/graphql/_generated';
import { WriteSmartReplyErrors } from './smartReplyTypes';

/**
 * Maps from GraphQL's error DTOs to Smart Reply errors
 */
export const ErrorMap: Record<string, string | undefined> = {
    [ISmartReplyErrorTypes.Moderation]: WriteSmartReplyErrors.moderation,
};
